import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useMemo, useState, } from 'react';
import { fetchCarsFromApi, fetchSiteFromApi } from '@/api/client';
import { carsData, mergeSeedKepUrlFromDefaults } from '@/data/cars';
import { publicAssetUrl } from '@/utils/publicAssetUrl';
import { normalizeCarConditionSheet } from '@/utils/carCondition';
import { normalizeCarDetailedData } from '@/utils/carDetails';
const LS_CARS = 'minimal-car-app-cars';
const LS_SITE = 'minimal-car-app-site';
export const LS_ADMIN_PASS = 'minimal-car-app-admin-password';
export const defaultSite = {
    logoUrl: publicAssetUrl('/pictures/logo.png'),
    heroAutoImage: publicAssetUrl('/pictures/kep1.png'),
    phoneTel: '+36204105803',
    phoneDisplay: '+36 20 410 5803',
    facebookUrl: 'https://www.facebook.com/profile.php?id=100051818982263',
    contactEmail: 'info@minimalcar.hu',
    contactAddressDisplay: 'Nyíregyháza-Oros, Élet utca 1',
    contactMapLatitude: null,
    contactMapLongitude: null,
    contactMapSearchQuery: 'Nyíregyháza-Oros, Élet utca 1',
    openingHoursShort: 'Hétfő – Péntek 08:00 – 17:00 · Szombat 09:00 – 13:00',
    openingHoursLong: 'Hétfő – Péntek: 08:00 – 17:00\nSzombat: 09:00 – 13:00\nVasárnap: Zárva',
    heroWelcome: 'Üdvözöljük a Minimal Car oldalán!',
    heroHeadline: 'Minőségi autó, Korrekt ár!',
    heroSubline: 'Használtautókereskedés Nyíregyházán!',
    heroCtaLabel: 'Készpénzes autófelvásárlás',
    feature1Title: 'Autófelvásárlás Nyíregyháza',
    feature1Text: 'Autófelvásárlás Nyíregyházán korrekt áron. Eladná autóját? Hozza be hozzánk, és azonnal készpénzben kifizetjük – hirdetés és komolytalan érdeklődők nélkül.',
    feature2Title: 'Teljes körű gépjármű ügyintézés',
    feature2Text: 'Biztosításkötés és okmányirodai ügyintézés vásárlóinknak. Megkíméljük a sorban állástól – kérje teljes körű gépjármű ügyintézés szolgáltatásunkat.',
    buySectionTitle: 'Azonnali készpénzes autófelvásárlás!',
    buySectionIntro: 'Válassza az autója eladásának gyors és kényelmes módját három rövid lépésben:',
    buyStep1Title: '1. Hozza el autóját!',
    buyStep1Text: 'Látogassa meg nyíregyházi autókereskedésünket. Időpont egyeztetés ajánlott, de nem kötelező.',
    buyStep2Title: '2. Átvizsgáljuk, ellenőrizzük.',
    buyStep2Text: 'Átvizsgáljuk az autót és az okmányokat. Piaci áron nem tudjuk megvenni, de szemtelenül alacsony árat sem mondunk.',
    buyStep3Title: '3. Készpénzben kifizetjük!',
    buyStep3Text: 'Ha elfogadja az ajánlatot, azonnal viheti a pénzt. A papírmunkát mi intézzük.',
    aboutTitle: 'Minimal Car',
    aboutBody: 'A Minimal Car nyíregyházi használtautó-kereskedés, több mint 20 év autókereskedelmi tapasztalattal a háttérben.\n\nGondosan válogatott használtautókkal, korrekt tájékoztatással és teljes körű ügyintézéssel várjuk vásárlóinkat.',
    aboutSignOff: 'Minimal Car',
    carsSectionTitle: 'Használtautók széles választéka!',
    carsCtaLabel: 'Megnézem a jelenlegi autókat',
    contactSectionTitle: 'Keressen fel minket!',
    detailsBannerTitle: 'Készpénzes autófelvásárlás Nyíregyházán',
    detailsLeadTitle: 'Legjobb készpénzes autófelvásárlás Nyíregyházán? Velünk lehetséges!',
    detailsLeadBody: 'Ha nem viszik el gyorsan autóját, úgy lemarad a kiszemelt új gépjárműről? Belefáradt már a sok alkudozó, komolytalan érdeklődőbe? Szemtelen áron vagy épp nem számolják be régi autóját az új gépkocsi vásárlásánál? Azonnali készpénzre van szüksége? Keresse bizalommal a Minimal Car autókereskedést. Mi segítünk, átnézzük, értékeljük autóját és ajánlatot teszünk rá. Amennyiben megegyezünk, úgy a gépjárművet azonnal adásvételi szerződéssel megvásároljuk.',
    detailsBrandsTitle: 'Szinte bármilyen márkát és modellt felvásárolunk!',
    detailsBrandsBody: 'Az autó értékelése egy átlátható, ám viszonylag összetett folyamat, amelynek során a felvásárlóinknak számtalan paramétert kell figyelembe vennie. Minden márkájú és típusú járművet megvásárolunk, 3,5 tonnáig.',
    whyTitle: 'Miért minket válasszon?',
    whyItems: 'Szuper gyorsan elintézzük az egész adásvételt papírmunkával együtt!\nKÉSZPÉNZZEL fizetünk!\nMi minden autómárkával foglalkozunk. Velünk könnyen megy az autófelvásárlás!\nTapasztaltak vagyunk, ismerjük a piaci trendeket és így a LEGJOBB ÁRAT tudjuk nyújtani.\nGYORSAN dolgozunk. Hozza el autóját és már kap is egy árajánlatot!\nAz autó azonnal lekerül a nevéről, így megszűnik a biztosítás, súlyadó vagy bármilyen fizetési kötelezettség.',
    docsTitle: 'Milyen iratok szükségesek a készpénzes eladásnál?',
    docsItems: 'AZ AUTÓ PAPÍRJAI (forgalmi engedély + törzskönyv)\nAZ AUTÓ (az összes kulcs, szervizkönyv, műbizonylatok, tanúsítványok – amennyiben bizonylatköteles átalakításon esett át)\nA TULAJDONOS (érvényes fényképes igazolvány + lakcímkártya)\nEGY PÉNZTÁRCA, AMIT KITÖMHETÜNK PÉNZZEL ÖNNEK!\nAMENNYIBEN CÉG A TULAJDONOS (cégkivonat + aláírási címpéldány + aláíró személy + érvényes igazolványa + lakcímkártyája + bélyegző)',
    quoteTitle: 'Kérjen árajánlatot vagy egyeztessen időpontot autófelvásárlásra!',
    quoteBody: 'Ha elfogadja az autófelvásárlási ajánlatunkat, egyeztetünk egy megfelelő időpontot az adásvételhez.\n\nAz autó átvételekor készpénzben megkapja az autó ellenértékét.\n\nIlyen egyszerű!',
};
function cloneDefaultCars() {
    return carsData.map((c) => ({
        ...c,
        detailedData: normalizeCarDetailedData(c.detailedData, c),
        conditionSheet: normalizeCarConditionSheet(c.conditionSheet, c),
    }));
}
function loadCarsFromLocalStorage() {
    try {
        const s = localStorage.getItem(LS_CARS);
        if (s === null)
            return cloneDefaultCars();
        const parsed = JSON.parse(s);
        return Array.isArray(parsed)
            ? mergeSeedKepUrlFromDefaults(parsed.map((c) => ({
                ...c,
                elkelt: Boolean(c.elkelt),
                detailedData: normalizeCarDetailedData(c.detailedData, c),
                conditionSheet: normalizeCarConditionSheet(c.conditionSheet, c),
            })))
            : cloneDefaultCars();
    }
    catch {
        return cloneDefaultCars();
    }
}
function loadSiteFromLocalStorage() {
    try {
        const s = localStorage.getItem(LS_SITE);
        if (s === null)
            return { ...defaultSite };
        const parsed = JSON.parse(s);
        return { ...defaultSite, ...parsed };
    }
    catch {
        return { ...defaultSite };
    }
}
export function getStoredAdminPassword() {
    return localStorage.getItem(LS_ADMIN_PASS) ?? 'admin';
}
export function setStoredAdminPassword(pw) {
    localStorage.setItem(LS_ADMIN_PASS, pw);
}
const SiteDataContext = createContext(null);
export const SiteDataProvider = ({ children }) => {
    const [cars, setCars] = useState([]);
    const [site, setSite] = useState(defaultSite);
    const [isLoading, setIsLoading] = useState(true);
    const [loadError, setLoadError] = useState(null);
    const [dataSource, setDataSource] = useState('local');
    const refreshFromApi = useCallback(async () => {
        setIsLoading(true);
        setLoadError(null);
        try {
            const [apiCars, apiSite] = await Promise.all([fetchCarsFromApi(), fetchSiteFromApi()]);
            setCars(apiCars);
            setSite({ ...defaultSite, ...apiSite });
            try {
                localStorage.setItem(LS_CARS, JSON.stringify(apiCars));
                localStorage.setItem(LS_SITE, JSON.stringify({ ...defaultSite, ...apiSite }));
            }
            catch {
                /* quota */
            }
            setDataSource('api');
        }
        catch (err) {
            const message = err instanceof Error ? err.message : 'Ismeretlen hiba';
            setLoadError(message);
            setCars(loadCarsFromLocalStorage());
            setSite(loadSiteFromLocalStorage());
            setDataSource('local');
        }
        finally {
            setIsLoading(false);
        }
    }, []);
    useEffect(() => {
        void refreshFromApi();
    }, [refreshFromApi]);
    const updateSite = useCallback((partial) => {
        setSite((prev) => {
            const next = { ...prev, ...partial };
            try {
                localStorage.setItem(LS_SITE, JSON.stringify(next));
            }
            catch {
                /* quota */
            }
            return next;
        });
    }, []);
    const replaceSite = useCallback((next) => {
        setSite(next);
        try {
            localStorage.setItem(LS_SITE, JSON.stringify(next));
        }
        catch {
            /* quota */
        }
    }, []);
    const value = useMemo(() => ({
        cars,
        setCars,
        site,
        updateSite,
        replaceSite,
        isLoading,
        loadError,
        dataSource,
        refreshFromApi,
    }), [cars, site, updateSite, replaceSite, isLoading, loadError, dataSource, refreshFromApi]);
    return _jsx(SiteDataContext.Provider, { value: value, children: children });
};
export function useSiteData() {
    const ctx = useContext(SiteDataContext);
    if (!ctx)
        throw new Error('useSiteData must be used within SiteDataProvider');
    return ctx;
}
